// Legacy CRA permission enum, after the consolidation in the portal-backend
// permission set (22 → 10 names). The enum KEYS are kept identical so every
// existing reference in this legacy app (`PermissionsAdminEnum.SUPER_ADMIN`,
// etc.) keeps compiling unchanged. Only the string VALUES are remapped onto
// the new permission names so JWT `permissions.includes(...)` checks resolve
// against names that are actually present in the token.
//
// Mapping mirrors the SQL data migration that remapped existing roles:
// see prisma/migrations/20260512113156_consolidate_permissions/migration.sql
//
// Note: this is NOT a legacy refactor — it's a translation table that lets
// the legacy gates resolve against the new permission names so existing
// users keep equivalent access. Replacing legacy's gating model entirely is
// a separate follow-up.
export enum PermissionsAdminEnum {
  ADMIN_MAIN = 'VIEW_USERS',
  SUPER_ADMIN = 'MANAGE_USERS',

  VIEW_APPLICATIONS_LIST = 'VIEW_APPLICATIONS_LIST',
  CREATE_APPLICATION = 'SUBMIT_APPLICATION',
  VIEW_SINGLE_APPLICATION = 'VIEW_APPLICATION',
  VIEW_APPLICATION_CROSSCHECK = 'VIEW_APPLICATION',
  VIEW_APPLICATION_DOCUMENTS = 'VIEW_APPLICATION',

  ADD_NEW_APPLICATION_DOCUMENT = 'MANAGE_APPLICATION_DOCUMENTS',
  VIEW_SINGLE_DOCUMENT = 'VIEW_APPLICATION',
  GCASH_DOCUMENT_OVERVIEW = 'VIEW_APPLICATION',
  VIEW_DOCUMENT_FIELDS_SECTION = 'VIEW_APPLICATION',
  VIEW_DOCUMENT_TRANSACTIONS_SECTION = 'VIEW_APPLICATION',
  VIEW_DOCUMENT_FRAUD_DETECTION_SECTION = 'VIEW_APPLICATION',
  ADD_DOCUMENT_PAGE = 'MANAGE_APPLICATION_DOCUMENTS',
  CHANGE_DOCUMENT_STATUS = 'MANAGE_APPLICATION_DOCUMENTS',
  EXPORT_DOCUMENT = 'EXPORT_APPLICATION_DATA',

  VIEW_REPORTS = 'VIEW_APPLICATION',
  EXPORT_REPORTS = 'EXPORT_APPLICATION_DATA',
  VIEW_ACTIVITIES = 'VIEW_AUDIT_LOGS',

  VIEW_HOME_PAGE = 'VIEW_APPLICATIONS_LIST',
  API_DOCUMENTATION_LINK = 'VIEW_APPLICATIONS_LIST',
}
